import script from "./tabs.vue?vue&type=script&setup=true&name=layout_tabs&lang=js"
export * from "./tabs.vue?vue&type=script&setup=true&name=layout_tabs&lang=js"

import "./tabs.vue?vue&type=style&index=0&id=37015ecc&lang=css"

const __exports__ = script;

export default __exports__